import React from "react";
import { Row, Col, Button, Modal, DatePicker } from "antd";
import commonStyles from "../../DashBoard/DashBoardMobile/DashBoardMobile.module.scss";
import moment from "moment";
import { RangePicker_Arrow } from "../../../assets/images";
import { usePaginationCtx } from "../../../context/PaginationContext";
import { useServiceUserProfileFilterActions } from "../../../hooks/useServiceUserProfileFilterActions";

type Props = {
  isOpenFilter: boolean;
  setIsOpenFilter: Function;
};

export const ServiceUserProfileFilter: React.FC<Props> = ({
  isOpenFilter,
  setIsOpenFilter,
}) => {
  const { activeTabCtx } = usePaginationCtx();
  const [activeTab] = activeTabCtx;

  const {
    selectedDateRanges,
    serviceTypesOptions,
    handleTypesClick,
    handleFilterDateRange,
    isActiveTabChecked,
    handleReset,
    handleApplyFilters,
  } = useServiceUserProfileFilterActions(setIsOpenFilter);

  const { RangePicker } = DatePicker;

  return (
    <>
      <Modal
        visible={isOpenFilter}
        width={540}
        centered
        className={commonStyles.filterModal}
        footer={
          <Row
            justify="center"
            gutter={[10, 0]}
            className={commonStyles.modalFilterFooterMargin}
          >
            <Col>
              <Button
                className={commonStyles.resetFilters}
                onClick={handleReset}
              >
                Reset
              </Button>
            </Col>
            <Col>
              <Button
                className={commonStyles.applyFilterBtn}
                onClick={handleApplyFilters}
              >
                Apply Filters
              </Button>
            </Col>
          </Row>
        }
      >
        <Row justify="center">
          <Col className={commonStyles.modalFilterHeadings}>Filter by...</Col>
        </Row>
        <Row className={commonStyles.filterHeadingMargin}>
          <Col span={24} className={commonStyles.filterHeadings}>
            Service Types
          </Col>
          <Col span={24} className={commonStyles.noRipple}>
            {serviceTypesOptions.map((option) => (
              <Button
                key={option}
                onClick={() => handleTypesClick(option)}
                className={
                  isActiveTabChecked(option)
                    ? commonStyles.filterCheckBtns
                    : commonStyles.filterUncheckBtns
                }
              >
                {option}
              </Button>
            ))}
          </Col>
        </Row>

        {activeTab !== "3" && (
          <Row className={commonStyles.filterHeadingMargin}>
            <Col span={24} className={commonStyles.filterHeadings}>
              Date Range
            </Col>
            <Col className={commonStyles.filterRangePicker}>
              <RangePicker
                format="MM/DD/YYYY"
                value={[
                  moment(selectedDateRanges[activeTab]?.startDate),
                  moment(selectedDateRanges[activeTab]?.endDate),
                ]}
                onChange={handleFilterDateRange}
                allowClear={false}
                separator={
                  <img src={RangePicker_Arrow} alt="RangePicker_Arrow" />
                }
              />
            </Col>
          </Row>
        )}
      </Modal>
    </>
  );
};
